import { Directive, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { first } from 'rxjs';
import { TelemonitoringJoinService } from '../services/telemonitoring-join.service';

@Directive({
  selector: '[telemonitoringLink]',
  host: {
    '(click)': 'onClick()',
  },
})
export class TelemonitoringLinkDirective {
  private telemonitoringId: number;

  private readonly router = inject(Router);
  private readonly telemonitoringJoinService = inject(TelemonitoringJoinService);

  @Input() clientCode: string;

  @Input() set telemonitoringLink(telemonitoringId: number) {
    this.telemonitoringId = telemonitoringId;
  }

  onClick(): void {
    this.telemonitoringJoinService
      .ensureUserJoined(this.telemonitoringId)
      .pipe(first())
      .subscribe({
        next: (joined) => {
          if (joined) {
            this.navigateToTelemonitoring();
          }
        },
      });
  }

  private navigateToTelemonitoring(): void {
    this.router.navigate(['/client', this.clientCode, 'telemonitorings', `${this.telemonitoringId}`], {
      queryParamsHandling: 'merge',
    });
  }
}
